export default (text: string): string[] => {
  return text.split("\n");
};
